module.exports = __webpack_public_path__ + "assets/img/69@3x.1141c399.png";